import React from 'react'
import { AboutObj, HomeObjOne, ServicesObj } from './Data'
import About from './About/About'
import Header from './header/header'
import Project from './Projects/project'
import Services from './Services/Services'
import Contact from './Contact/contact'

function Home() {
    return (
        <>
            <Header {...HomeObjOne} />
            <About {...AboutObj} />
            <Project />
            <Services {...ServicesObj} />
            <Contact />
        </>
    )
}

export default Home
